import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { LoginFormModule } from "src/app/epicare-public/login/views/login-page/components/login-form/login-form.module";
import { InvitationErrorTranslationPrefixPipe } from "../../domain/pipes/invitation-error-translation-prefix.pipe";
import { InvitationEmailFormComponent } from "./components/invitation-email-form/invitation-email-form.component";
import { InvitationPasswordFormComponent } from "./components/invitation-password-form/invitation-password-form.component";
import { InvitationPageComponent } from "./invitation-page.component";

@NgModule({
  declarations: [
    InvitationPageComponent,
    InvitationEmailFormComponent,
    InvitationPasswordFormComponent,
    InvitationErrorTranslationPrefixPipe,
  ],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, LucideAngularModule, LoginFormModule],
})
export class InvitationModule {}
